import { useContext, useState } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import ItemDetails from "./ItemDetails"
import EditItem from "./EditItem"
import { toast } from 'react-toastify'
import { useRef } from 'react'

const Item=({item})=>{

    const{deleteItem}=useContext(ItemsContext)
    const [showEdit, setShowEdit]=useState(false)
    const [showDetails, setShowDetails]=useState(false)
    const [buttonText, setButtonText] = useState('Edit')
    const [buttonText2, setButtonText2] = useState('Details')
    const myButtonRef = useRef(null)

    const handleEdit=()=>{
         setShowEdit(current=>!current)
         setButtonText(buttonText === 'Edit' ? 'CLOSE' : 'Edit')
         if (myButtonRef.current){
            myButtonRef.current.scrollIntoView({ behavior: 'smooth' })
            }
  
     
     }
     const handleDetails=()=>{
         setShowDetails(current=>!current)
         setButtonText2(buttonText2 === 'Details' ? 'CLOSE' : 'Details')
         if (myButtonRef.current){
         myButtonRef.current.scrollIntoView({ behavior: 'smooth' })
         }
    
    
     }
 
    const handleDelete=()=>{   
            deleteItem(item.id)
            toast.success("The item has been DELETED")
            //setTimeout(()=>{alert("The item has been DELETED.")},100)
            if (myButtonRef.current){
                myButtonRef.current.scrollIntoView({ behavior: 'smooth' })
                }
        }
        
    
    
    return(
     
        <div className="item" ref={myButtonRef}>
            <div>
            <p>Title: <strong>{item.title}</strong></p>
            <p>Fulfilled: <strong>{item.fulfilled?"Yes":"No"}</strong></p>          
          <button onClick={handleDelete}>Delete</button>
          <button onClick={handleDetails}>{buttonText2}</button>
          <button onClick={handleEdit}>{buttonText}</button>       
            </div>
                    <div className="itemPlus">
                        {showDetails && !showEdit && <ItemDetails item={item} handleDetails={handleDetails}/>}
                        {showEdit && !showDetails && <EditItem item={item} handleEdit={handleEdit}/>} 
                    </div>         
        </div>
                   
    
    )
}

export default Item